import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cwt-page-footer',
  templateUrl: './page-footer.component.html',
  host: { class: 'cwt-page-footer' }
})
export class PageFooterComponent { }
